module.exports = __webpack_public_path__ + "static/media/Behance.dbf2d751.svg";